import { IAuditLogList } from "../models/AuditLogModel";

const appendAuditLogs = (
  current: IAuditLogList,
  next: IAuditLogList
): IAuditLogList => ({
  auditLogs: [...(current.auditLogs ?? []), ...(next.auditLogs ?? [])],
  paginationToken: next.paginationToken,
});

export { appendAuditLogs };
